export default "__VITE_ASSET__CLSftuOI__"